import React from 'react';

import { PatientForm as StyledPatientForm } from './PatientForm.styles';

import Loading from "../../components/Loading";

import * as FieldUtils from '../../utils/field';
import * as FileUtils from '../../utils/file';

const FORM_TYPE = {
	HEALTH: 'HEALTH',
	UNHEALTH: 'UNHEALTH'
};

function PatientForm({
	form,
	isDesktop,
	loading,
	isValidForm,
	onSubmit,
	fieldsByPage,
	currentPage,
	totalPages,
	handleChange,
	onClearForm,
	values,
	uploadFiles,
	onClickSignatureBox,
	onAttachFileClick,
	onBackStepClick,
	onContinueStepClick,
	removeFile
}) {
	if (loading || !form) {
		return (
			<div className="ds-flex ds-flex__item ds-flex__align--center h-100">
				<Loading />
			</div>
		);
	}

	return (
		<div className={`doca bg--light-dark doca-flex ${isDesktop ? 'desktop-container' : 'mobile-container'}`}>
			<div className={`doca-flex doca-flex-col doca-page ${isDesktop ? 'form-field-container--desktop' : ''}`}>
				<div>
					<p className="doca-text--large doca-text--medium doca-text--dark doca-text-word-break w-100">{form.title}</p>

					{form.description && (
						<>
							<hr className="doca-separator" />
							<p className="doca-text--normal doca-text--gray doca-text-word-break w-100">{form.description}</p>
						</>
					)}
				</div>

				{totalPages > 1 ? (
					<div className='doca-mt-3'>
						<label className="doca-steps__label">
							Página {currentPage} de {totalPages}
						</label>

						<div className="doca-steps__container doca-m-0">
							{Array.from({ length: totalPages }).map((item, index) => {
								const page = index + 1;

								return <div className={`doca-steps doca-steps--primary ${page > 1 ? 'doca-ml-2' : ''} ${currentPage > page ? 'doca-steps--done' : ''} ${currentPage === page ? 'doca-steps--current' : ''}`}  />;
							})}
						</div>
				  </div>
				) : null}

				<form className="doca-form doca-mt-6" onSubmit={onSubmit}>
					{fieldsByPage.length ? fieldsByPage.map(field => {
						const fieldName = FieldUtils.getFieldName(field);

						return (
							<div className="doca-page__box" key={field.id}>
								<div className="doca-form doca-flex doca-justify-between">
									<div className={`doca-form__field ${field.required ? 'doca-form__field--required' : ''} ${field.type === 'PAGE' ? 'doca-flex-1' : ''}`}>
										<label className="doca-text--dark doca-text--medium doca-text-word-break">
											{field.title}
										</label>

										{field.description && (
											<>
												<hr className="doca-separator" />

												<p className="doca-text--normal doca-text--gray preline-text w-100 doca-text-word-break">{field.description}</p>
											</>
										)}
									</div>

									{field.type === 'FILE' && values[fieldName]?.length ? (
										<button type="button" className="doca-button doca-button--secondary" onClick={() => onAttachFileClick(field)}>
											<i className="doca-icon doca-icon__plus" />
										</button>
									) : null}
								</div>

								<div className="doca-mt-4">
									{field.type === 'TEXT' && (
										<textarea
											maxLength={1000}
											className="doca-form-control"
											placeholder="Texto da resposta"
											onChange={handleChange}
											name={fieldName}
											value={values[fieldName]}
											required={field.required}
											rows="4"
										></textarea>
									)}

									{field.type === 'MULTIPLE_CHOICE_GRADE' && (
										<table className="doca-table doca-table--borderless signbox-multiple-choice-grade-table">
											<thead>
												<tr>
													<th width="120" scope="col"></th>

													{field.columns.map(column => (
														<th width="120" ng-repeat="column in field.columns" className="doca-text doca-text--small doca-text--normal doca-text-center doca-text-word-break" scope="col">
															{column.label}
														</th>
													))}
												</tr>
											</thead>

											<tbody>
												{field.options.map((option, index) => {
													return (
														<tr className="signbox-multiple-choice-grade-table__row doca-mt-1">
															<td width="120" className="doca-text doca-text--small doca-text-word-break">{option.label}</td>

															{field.columns.map(column => {
																const isChecked = values[fieldName][option.id] === column.id.toString();

																return (
																	<td width="120">
																		<div className="doca-flex doca-justify-center">
																			<div className="doca-radio__container">
																				<input name={`${fieldName}.${option.id}`} checked={isChecked} onChange={handleChange} value={column.id} className="doca-radio" type="radio" />
																			</div>
																		</div>
																	</td>
																);
															})}
														</tr>
													);
												})}
											</tbody>
										</table>
									)}

									{field.type === 'CHECKBOX' && (
										field.options.map(option => {
											const optionId = FieldUtils.getFieldOptionId(field, option);
											const isChecked = values[fieldName].includes(option.id.toString());

											return (
												<div className="doca-checkbox__container doca-mb-2" key={option.id}>
													<div>
														<input onChange={handleChange} className="doca-checkbox doca-mr-2" checked={isChecked} id={optionId} name={fieldName} type="checkbox" value={option.id} />
													</div>

													<label className="doca-form__label doca-form__label--inline doca-text-word-break" htmlFor={optionId}>
														{option.label}
													</label>
												</div>
											);
										})
									)}

									{field.type === 'RADIO' && (
										field.options.map(option => {
											const optionId = FieldUtils.getFieldOptionId(field, option);
											const isChecked = values[fieldName] === option.id.toString();

											return (
												<div className="doca-radio__container doca-mb-2" key={option.id}>
													<div>
														<input onChange={handleChange} checked={isChecked} className="doca-radio doca-mr-2" id={optionId} name={fieldName} value={option.id} type="radio" />
													</div>

													<label className="doca-form__label doca-form__label--inline doca-text-word-break" htmlFor={optionId}>
														{option.label}
													</label>
												</div>
											)
										})
									)}

									{field.type === 'FILE' && (
										<div className="doca-flex">
											<button hidden={values[fieldName].length} type="button" className="doca-card doca-flex-1 doca-text--small doca-text-center doca-text--gray cpointer bg--light-low attach-file-card" onClick={() => onAttachFileClick(field)}>
												Clique aqui para anexar arquivos

												<input hidden type="file" name="files" id={`upload-image-${field.id}`} onChange={event => uploadFiles({ event, field })} accept="image/*,.pdf" multiple />
											</button>


											{values[fieldName].length ? (
												<div className="doca-flex doca-flex-wrap">
													{values[fieldName].map((file, index) => (
														<button type="button" className="doca-button doca-button--secondary doca-mt-2 doca-mr-2" key={`FILE_${fieldName}_${index}`} onClick={() => removeFile(field, index)}>
															<i className={`doca-icon doca-mr-2 doca-icon__${file.type.includes('application/pdf') ? 'file-pdf' : 'image'}`} />

															<span className='text-truncate text-ellipsis'>{FileUtils.clearFileName(file.name)}</span>


															<i className="doca-icon doca-icon__xmark doca-icon--large doca-ml-2" />
														</button>
													))}
												</div>
											) : null}
										</div>
									)}
								</div>
							</div>
						);
					}) : null}
				</form>

				<div className={`doca-mt-4 doca-flex ${isDesktop ? 'doca-pb-4' : 'doca-flex-col'}`}>
					<button type="reset" className={`doca-button doca-button--large doca-button--secondary ${isDesktop ? 'doca-mr-2' : 'doca-button--block doca-mb-2'}`} onClick={onClearForm}>
						<i className="doca-icon doca-icon__trash" />

						Limpar formulário
					</button>

					{currentPage !== 1 && (
						<button className={`doca-button doca-button--large doca-button--secondary ${isDesktop ? totalPages !== currentPage ? 'doca-mr-2' : '' : 'doca-mb-2 doca-button--block'}`} onClick={onBackStepClick}>
							<i className="doca-icon doca-icon__arrow-left" />

							Voltar
						</button>
					)}

					{totalPages !== currentPage && (
						<button className={`doca-button doca-button--large doca-button--primary ${isDesktop ? '' : 'doca-button--block doca-mb-2'}`} onClick={onContinueStepClick}>
							Próximo

							<i className="doca-icon doca-icon__arrow-right" />
						</button>
					)}

					{form.type === FORM_TYPE.UNHEALTH && (
						<button className={`doca-button doca-button--large doca-button--primary ${isDesktop ? 'doca-ml-2' : 'doca-button--block'}`} onClick={onSubmit}>
							Concluir e enviar
						</button>
					)}
				</div>
			</div>


			{form.type === FORM_TYPE.HEALTH && totalPages === currentPage && (
				<div className={`doca-page  ${isDesktop ? 'signature-box-container--desktop' : 'signature-box-container--mobile'}`}>
					<div className="doca-page__box">
						<p className="doca-text--medium doca-text--large">
							Para finalizar, assine o questionário
						</p>

						<StyledPatientForm.SignatureBox className="doca-mt-6" hasSignature={!!form?.signature_url} onClick={onClickSignatureBox}>
							{form?.signature_url ? (
								<StyledPatientForm.SignatureBox.Image src={form.signature_url} />
							) : (
								<StyledPatientForm.SignatureBox.Placeholder className="doca-text--small">Clique aqui para assinar o questionário</StyledPatientForm.SignatureBox.Placeholder>
							)}
						</StyledPatientForm.SignatureBox>


						<div className="doca-text-center doca-mt-4">
							<button className="doca-button doca-button--primary doca-button--large doca-button--block" disabled={!isValidForm || (form.type === FORM_TYPE.HEALTH && !form.signature_url)} onClick={onSubmit}>Assinar e concluir</button>
						</div>

						<p className="doca-mt-4 doca-text--extra-small doca-text-center">Para concluir o processo de assinatura é necessário inserir as informações solicitadas e clicar no botão "Assinar e Concluir"</p>
					</div>
				</div>
			)}
		</div>
	);
}

export default PatientForm;
